import React from 'react';
import CustomMedia from 'util/custom-media-query';
import { Field } from 'react-final-form';
import i18n from 'i18n';
import Image from 'components/common/Image';
import { applyStyles } from 'util/helpers';
import FontStyles from 'constants/font-styles';
import styled from 'styled-components';
import Colors from 'constants/colors';
import Button from 'components/common/Button';
import imgOverpaper1PC1x from 'assets/images/PC/@1x/img_overpaper1.png';
import imgOverpaper1PC2x from 'assets/images/PC/@2x/img_overpaper1@2x.png';
import imgOverpaper1SP2x from 'assets/images/SP/@2x/img_overpaper1@2x.png';
import imgOverpaper1SP3x from 'assets/images/SP/@3x/img_overpaper1@3x.png';
import imgOverpaper2PC1x from 'assets/images/PC/@1x/img_overpaper2.png';
import imgOverpaper2PC2x from 'assets/images/PC/@2x/img_overpaper2@2x.png';
import imgOverpaper2SP2x from 'assets/images/SP/@2x/img_overpaper2@2x.png';
import imgOverpaper2SP3x from 'assets/images/SP/@3x/img_overpaper2@3x.png';
import imgOverpaper3PC1x from 'assets/images/PC/@1x/img_overpaper3.png';
import imgOverpaper3PC2x from 'assets/images/PC/@2x/img_overpaper3@2x.png';
import imgOverpaper3SP2x from 'assets/images/SP/@2x/img_overpaper3@2x.png';
import imgOverpaper3SP3x from 'assets/images/SP/@3x/img_overpaper3@3x.png';
import imgOverpaper4PC1x from 'assets/images/PC/@1x/img_overpaper4.png';
import imgOverpaper4PC2x from 'assets/images/PC/@2x/img_overpaper4@2x.png';
import imgOverpaper4SP2x from 'assets/images/SP/@2x/img_overpaper4@2x.png';
import imgOverpaper4SP3x from 'assets/images/SP/@3x/img_overpaper4@3x.png';

const data = [
  {
    value: i18n.t('orderAggregators:common:order.wrappingType1Name'),
    description: (
      <div className="description">
        <dt>{i18n.t('orderAggregators:common:order.wrappingType1Name')}</dt>
      </div>
    ),
    image: {
      pc1x: imgOverpaper1PC1x,
      pc2x: imgOverpaper1PC2x,
      sp2x: imgOverpaper1SP2x,
      sp3x: imgOverpaper1SP3x,
      alt: 'img_overpaper_1'
    }
  },
  {
    value: i18n.t('orderAggregators:common:order.wrappingType2Name'),
    description: (
      <div className="description">
        <dt>{i18n.t('orderAggregators:common:order.wrappingType2Name')}</dt>
        <dd>
          {i18n.t('orderAggregators:common:order.wrappingType2Description')}
        </dd>
      </div>
    ),
    image: {
      pc1x: imgOverpaper2PC1x,
      pc2x: imgOverpaper2PC2x,
      sp2x: imgOverpaper2SP2x,
      sp3x: imgOverpaper2SP3x,
      alt: 'img_overpaper_2'
    }
  },
  {
    value: i18n.t('orderAggregators:common:order.wrappingType3Name'),
    description: (
      <div className="description">
        <dt>{i18n.t('orderAggregators:common:order.wrappingType3Name')}</dt>
        <dd>
          {i18n.t('orderAggregators:common:order.wrappingType3Description')}
        </dd>
      </div>
    ),
    image: {
      pc1x: imgOverpaper3PC1x,
      pc2x: imgOverpaper3PC2x,
      sp2x: imgOverpaper3SP2x,
      sp3x: imgOverpaper3SP3x,
      alt: 'img_overpaper_3'
    }
  },
  {
    value: i18n.t('orderAggregators:common:order.wrappingType4Name'),
    description: (
      <div className="description">
        <dt>{i18n.t('orderAggregators:common:order.wrappingType4Name')}</dt>
        <dd>
          {i18n.t('orderAggregators:common:order.wrappingType4Description')}
        </dd>
      </div>
    ),
    image: {
      pc1x: imgOverpaper4PC1x,
      pc2x: imgOverpaper4PC2x,
      sp2x: imgOverpaper4SP2x,
      sp3x: imgOverpaper4SP3x,
      alt: 'img_overpaper_4'
    }
  }
];

const DialogBodyTemplate = ({ className }) => (
  <div className={className}>
    <p className="header-text">
      {i18n.t('orderAggregators:common:order.wrappingTypeSelect')}
    </p>
    <dl className="radio-container">
      {data.map(selection => (
        <label className="selection" key={selection.value}>
          <Field
            type="radio"
            name="wrappingType"
            value={selection.value}
            render={({ input }) => {
              return (
                <div
                  className={`selection-inner ${
                    input.checked ? '' : 'hovered'
                  }`}
                >
                  <input
                    type="radio"
                    {...input}
                    className={input.checked ? 'checked' : ''}
                  />
                  <Image {...selection.image} />
                  {selection.description}
                </div>
              );
            }}
          />
        </label>
      ))}
    </dl>
  </div>
);

const bodyPCStyle = CustomMedia.greaterThan('umedium')`
  padding: 32px;

  .header-text {
    ${FontStyles.text10};

    margin: 0 0 32px;
    color: ${Colors.black1};
  }

  .radio-container {
    display: flex;
    flex-wrap: wrap;
  }

  .selection {
    display: block;
    width: 50%;
    margin-bottom: 32px;

    &:nth-child(odd) dd::before {
      width: 163px;
    }

    &:nth-child(even) dd::before {
      width: 100%;
    }
  }

  .selection-inner{
    display: flex;

    &:hover {
      color: ${Colors.orange1};
      cursor: pointer;
    }
  }

  .selection-inner:hover picture{
    cursor: pointer;
    img {
      opacity: 0.4;
    }
  }

  .selection-inner:hover dd {
    ${FontStyles.text10};
    cursor: pointer;
    margin: 15px 0 0 0;

    &::before {
      display: block;
      height: 1px;
      margin-bottom: 15px;
      background-color: ${Colors.orange1};
      content: '';
    }
  }

  input[type=radio] {
    display: none;
  }

  picture {
    position: relative;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
      background-color: transparent;
      box-shadow: 0 0 0 1px ${Colors.gray2} inset;
      content: '';
    }
  }

  input.checked + picture::after {
    box-shadow: 0 0 0 6px ${Colors.orange1} inset;
  }

  img {
    max-width: 100%;
  }

  .hidden {
    display: none;
  }

  .description {
    margin-left: 15px;
    width: 184px;
    flex-shrink: 0;
  }

  dt {
    ${FontStyles.text5};
  }

  dd {
    ${FontStyles.text10};

    margin: 15px 0 0 0;

    &::before {
      display: block;
      height: 1px;
      margin-bottom: 15px;
      background-color: ${Colors.black1};
      content: '';
    }
  }
`;

const bodySPStyle = CustomMedia.lessThan('medium')`
  padding: 16px;

  .header-text {
    ${FontStyles.text6};

    margin: 0 0 24px;
    color: ${Colors.black1};
  }

  .radio-container {
    display: flex;
    flex-wrap: wrap;
  }

  .selection-inner {
    display: flex;
    margin-bottom: 16px;
  }

  input[type=radio] {
    display: none;
  }

  picture {
    position: relative;

    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: block;
      background-color: transparent;
      box-shadow: 0 0 0 1px ${Colors.gray2} inset;
      content: '';
    }
  }

  input.checked + picture::after {
    box-shadow: 0 0 0 4px ${Colors.orange1} inset;
  }

  img {
    max-width: 100%;
  }

  .hidden {
    display: none;
  }

  .description {
    margin-left: 16px;
    width: 184px;
    flex-shrink: 0;
  }

  dt {
    ${FontStyles.text5};
  }

  dd {
    ${FontStyles.text10};

    margin: 15px 0 0 0;

    &::before {
      display: block;
      height: 1px;
      margin-bottom: 15px;
      background-color: ${Colors.black1};
      content: '';
    }
  }
`;

export const DialogBody = applyStyles(DialogBodyTemplate)(
  bodyPCStyle,
  bodySPStyle
);

const getButtonComponent = (value, handleSubmit, onClickNext) => {
  if (value === i18n.t('orderAggregators:common:order.wrappingType1Name')) {
    return (
      <Button buttonType="B" type="button" onClick={handleSubmit}>
        {i18n.t('common:save')}
      </Button>
    );
  }

  return (
    <Button buttonType="C" type="button" onClick={onClickNext}>
      {i18n.t('orderAggregators:common:order.wrappingTypeNext')}
    </Button>
  );
};

const DialogFooterTemplate = ({
  className,
  form,
  handleSubmit,
  onClickNext
}) => {
  const value =
    form.getFieldState('wrappingType') &&
    form.getFieldState('wrappingType').value;

  return (
    <div className={className}>
      {getButtonComponent(value, handleSubmit, onClickNext)}
    </div>
  );
};

export const DialogFooter = styled(DialogFooterTemplate)`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/OrderAggregators/components/WrappingTypeDialogCompoents.js